import TimeReportsCollection from "../../model2/time-report/collection";
import {momentRange} from "../convert/moment-range";


export enum TimerState {
    TIMER_INACTIVE  = 0,
    TIMER_ACTIVE    = 1,
    TIMER_PAUSED    = 2,
    TIMER_STOPPED   = 3
}

export function getTaskTotalReportedTime(task:any) {
    if (!task || !task.timeReports) return 0
    let time
    if (task.timeReports instanceof TimeReportsCollection) {
        time = _.reduce(task.timeReports.models, (accumulator, curr) =>  accumulator + curr.reportedTime, 0)
    } else {
        time = _.reduce(task.timeReports, (accumulator, curr) =>  accumulator + curr.reportedTime, 0)
    }
    return time * 60000;
}


export default class Timer {

    public task : any
    public taskId : ID
    public intervalTimer : any = null   // JS Interval timer

    public startDate? : Date | null = null;
    public deltaTime : number = 0

    public prevReportedTime : any


    public state : TimerState =  TimerState.TIMER_INACTIVE

    constructor(task:any) {

        this.task = task;
        this.taskId = task.id;
        this.prevReportedTime = getTaskTotalReportedTime(task);
    }

    isActive() {
        return this.state === TimerState.TIMER_ACTIVE;
    }

    isPaused() {
        return this.state === TimerState.TIMER_PAUSED;
    }

    isStoppable() {
        return this.state === TimerState.TIMER_ACTIVE || this.state === TimerState.TIMER_PAUSED;
    }

    start() {
        if (this.isActive()) return;

        if (!this.startDate) this.startDate = new Date();

        this.intervalTimer = setInterval(this._tick, 1000);
        this.state = TimerState.TIMER_ACTIVE;
    }

    pause() {
        if (this.state !== TimerState.TIMER_ACTIVE) return;
        this.state = TimerState.TIMER_PAUSED;
        this.deltaTime += this.getCurrIntervalTime();
        this.startDate = null;
        this._stopTimer();
    }

    stop() {
        this.state = TimerState.TIMER_STOPPED;
        this.prevReportedTime += this.getTime(); // to save in storage correct value
        this.deltaTime = 0;
        this.startDate = null;
        this._stopTimer();
    }

    cancel() {
        gd.taskTimers.cancelTimer(this.task.id, ()=>{
            gd.taskTray.remove(this.task.id)
        })
    }

    _tick = () => {
        if (this.state !== TimerState.TIMER_ACTIVE) return;
        gd.bus.triggerEvent('task-timers:tick',this.taskId);
    }

    _stopTimer() {
        if (this.intervalTimer) {
            clearInterval(this.intervalTimer);
            this.intervalTimer = null;
        }
    }

    destroy() {
        this._stopTimer();
    }

    getCurrIntervalTime() {
        // @ts-ignore
        return this.startDate ? new Date() - this.startDate : 0;
    }

    get timeInMinutes() {
        const minutes : number = this.getTime() / 60000;
        return Math.ceil(minutes)
    }

    getTime() {
        return this.deltaTime + this.getCurrIntervalTime();
    }

    get startEnd():MomentRange {
        const end   = moment()
        const start = moment().subtract(this.getTime(), 'milliseconds')

        return momentRange(start, end)
    }

}